import React from 'react'
import styles from './PillSwitcher.module.css'

const PillSwitcher = ({ activeView, onViewChange }) => {
    return (
        <div className={styles.pillContainer}>
            <button
                className={`${styles.pill} ${activeView === 'shortlist' ? styles.active : ''}`}
                onClick={() => onViewChange('shortlist')}
                data-tooltip="Your weekly top 20, with tailored actions for each"
            >
                Weekly Shortlist
            </button>
            <button
                className={`${styles.pill} ${activeView === 'feed' ? styles.active : ''}`}
                onClick={() => onViewChange('feed')}
                data-tooltip="Browse and explore your personalised content"
            >
                Discover
            </button>
        </div>
    )
}

export default PillSwitcher
